<script setup lang="ts">
import { YoutubeIcon } from 'assets/data/icons';
const Icon = useIcon();
</script>
<template>
  <Icon :path="YoutubeIcon" :size="24" class="w-8" filled />
</template>
